import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlockUIService {

  static ERROR_MESSAGE = 'The selected AI model (e.g., Gemini, Meta, or Claude) has temporarily exceeded its usage limit. Please try again in a minute. Gemini allows up to 20 requests per minute and refreshes every 60 seconds.';

  constructor() { }

  private isLoading = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoading.asObservable();

  private errorMessage = new BehaviorSubject<string | null>(null);
  errorMessage$ = this.errorMessage.asObservable();

  start(): void {
    this.isLoading.next(true);
    this.errorMessage.next(null);
  }

  stop(): void {
    this.isLoading.next(false);
  }

  fail(message: string): void {
    this.isLoading.next(false);
    this.errorMessage.next(message);
  }

}
